import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import GalleryIcon from './GalleryIcon';

import css from './ProductGallery.css';

const GalleryZoomControls = props => {
  const { percent, canZoomIn, canZoomOut, disabled, zoomRef } = props;
  const intl = useIntl();
  
  const run = action => {
    const zoom = zoomRef.current;
    if (!zoom || zoom.disabled) return;
    if (action === 'reset') zoom.changeZoom(1);
    else zoom[action]();
  };

  return (
    <div
      className={css.zoomControls}
      onPointerDown={event => event.stopPropagation()}
      onWheel={event => event.stopPropagation()}
      onKeyDown={event => {
        if (event.key.startsWith('Arrow')) event.stopPropagation();
      }}
    >
      <div className={css.zoomToolbar} role="group" aria-label={intl.formatMessage({ id: 'ProductGallery.zoomControls' })}>
        <button
          type="button"
          className={css.control}
          aria-label={intl.formatMessage({ id: 'ProductGallery.zoomOut' })}
          title={intl.formatMessage({ id: 'ProductGallery.zoomOut' })}
          disabled={disabled || !canZoomOut}
          onClick={() => run('zoomOut')}
        >
          <GalleryIcon name="minus" />
        </button>
        <span className={css.scale} aria-live="off">
          {percent}%
        </span>
        <button
          type="button"
          className={css.control}
          aria-label={intl.formatMessage({ id: 'ProductGallery.zoomIn' })}
          title={intl.formatMessage({ id: 'ProductGallery.zoomIn' })}
          disabled={disabled || !canZoomIn}
          onClick={() => run('zoomIn')}
        >
          <GalleryIcon name="plus" />
        </button>
        <button
          type="button"
          className={css.control}
          aria-label={intl.formatMessage({ id: 'ProductGallery.reset' })}
          title={intl.formatMessage({ id: 'ProductGallery.reset' })}
          disabled={disabled || !canZoomOut}
          onClick={() => run('reset')}
        >
          <GalleryIcon name="reset" />
        </button>
      </div>
    </div>
  );
};

export default memo(GalleryZoomControls);
